class BlockchainTransactions {
  constructor({ _id, hash, memo}) {
    this.id = _id;
    this.hash = hash;
    this.memo = memo;

  }
}
export default BlockchainTransactions;